import { cn } from "@/lib/utils";
import { ButtonChatProps } from "../../types";

const IconContainer: React.FC<{ icon: JSX.Element }> = ({ icon }) => (
    <div
        className={cn(
            "relative flex h-[20px] max-h-[20px] min-h-[20px] w-[20px] min-w-[20px] max-w-[20px] items-center justify-center",
            "2xs:h-[20px] 2xs:max-h-[20px] 2xs:min-h-[20px] 2xs:w-[20px] 2xs:min-w-[20px] 2xs:max-w-[20px]",
            "4k:h-[90px] 4k:max-h-[90px] 4k:min-h-[90px] 4k:w-[90px] 4k:min-w-[90px] 4k:max-w-[90px]",
        )}
    >
        {icon}
    </div>
);

const ButtonChat: React.FC<ButtonChatProps> = ({
    children = null,
    className,
    variant = "primary",
    iconLeft,
    iconRight,
    ...rest
}) => {
    return (
        <button
            type="button"
            className={cn(
                "h-full w-full rounded-full ",
                [
                    variant === "primary" &&
                    "bg-whiteShade-40 border border-whiteShade-65 shadow-button-stele-primary-outer-mobile active:bg-whiteShade-70 lg:shadow-button-stele-primary-outer-desktop 4k:border-4 4k:shadow-button-stele-primary-outer-stele",
                    variant === "secondary" &&
                    "bg-grayShade-20 shadow-button-stele-secondary-outer-mobile active:bg-grayShade-50 lg:shadow-button-stele-secondary-outer-desktop 4k:shadow-button-stele-secondary-outer-stele",
                    variant === "cancel" &&
                    "border border-whiteShade-65 bg-red-cancel shadow-button-stele-cancel-outer-mobile lg:border-2 lg:shadow-button-stele-cancel-outer-desktop 4k:border-4 4k:shadow-button-stele-cancel-outer-stele",
                    variant === "onCard" && "bg-neutral-700 bg-opacity-65 active:bg-opacity-75",
                ],
                className,
            )}
            {...rest}
        >
            <div
                className={cn(
                    "relative flex h-full w-full items-center justify-center rounded-full font-frutigerBold font-bold",
                    "px-[14px] py-[8px] text-[16px] leading-[100%] text-white backdrop-blur-[53px] text-shadow-button-stele-primary-mobile",
                    "2xs:px-[14.5px] 2xs:py-[11px] 2xs:text-[16px]",
                    "lg:px-[16px] lg:py-[12px] lg:text-[18px] lg:backdrop-blur-[80px] lg:text-shadow-button-stele-primary-desktop",
                    "4k:px-[64px] 4k:py-[48px] 4k:text-[72px] 4k:backdrop-blur-[320px] 4k:text-shadow-button-stele-primary-stele",
                    [
                        variant === "primary" &&
                        "border border-whiteShade-65 bg-button-stele-primary-gradient shadow-button-stele-primary-inner-mobile lg:shadow-button-stele-primary-inner-desktop 4k:border-4 4k:shadow-button-stele-primary-inner-stele",
                        variant === "secondary" && "py-[9px]",
                        variant === "cancel" &&
                        "active:bg-whiteShade-40 bg-whiteShade-10 shadow-button-stele-cancel-inner-mobile lg:shadow-button-stele-cancel-inner-desktop 4k:shadow-button-stele-cancel-inner-stele",
                    ],
                    [(iconLeft || iconRight) && "justify-between 4k:py-[35px]"],
                    [
                        children === null && "justify-center"
                    ]
                )}
            >
                {iconLeft && <IconContainer icon={iconLeft} />}
                {children}
                {iconRight && <IconContainer icon={iconRight} />}
            </div>
        </button>
    );
};

export default ButtonChat;
